module.exports = __webpack_public_path__ + "static/media/laundry_welcome_packet.9869f05a.pdf";